// import { useContext, useEffect, useState } from 'react';
// import { useForm } from 'react-hook-form';
// import { SidebarContext } from 'context/SidebarContext';
// import VehicleAllotServices from 'services/VehicleAllotServices';
// import { AdminContext } from 'context/AdminContext';
// import { notifyError, notifySuccess } from 'utils/toast';

// const useVehicleAllotSubmit = (data, tab, choice, action) => {
// 	const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
// 	const { state } = useContext(AdminContext);
// 	const { adminInfo } = state;
// 	const [isSubmitting, setIsSubmitting] = useState(false);
// 	const [selectedVehicle, setSelectedVehicle] = useState(
// 		data?.va_vehicle_id?.toString()
// 	);
// 	const [selectedDriver, setSelectedDriver] = useState(
// 		data?.va_driver_id?.toString()
// 	);
// 	const [driverName, setdriverName] = useState(data?.driverName?.toString());
// 	const [vehicleName, setvehicleName] = useState(data?.vehicleName?.toString());
// 	const [startDate, setStartDate] = useState(null);
// 	const [allotvehicle, setAllotVehicle] = useState(null);
// 	const [alreadyAssignedVehicle, setAlreadyAssignedVehicle] = useState([]);
// 	const [alreadyAssignedDriver, setAlreadyAssignedDriver] = useState([]);
// 	const [allotdriver, setAllotDriver] = useState(null);
// 	const [endDate, setEndDate] = useState(null);
// 	const[rideStartDate,setRideStartDate]=useState(null);
// 	const[rideEndDate,setRideEndDate]=useState(null)
// 	const [changeReason, setChangeReason] = useState('');
// 	const [step, setStep] = useState(1);
// 	const [loading, setLoading] = useState(false);
// 	const parseDate = (dateStr) => {
// 		const [day, month, year] = dateStr.split('-');
// 		return new Date(`${year}-${month}-${day}`);
// 	};

// 	function formatDate(dateString) {
// 		const date = new Date(dateString);
// 		const day = String(date.getDate()).padStart(2, '0');
// 		const month = String(date.getMonth() + 1).padStart(2, '0');
// 		const year = date.getFullYear();
// 		return `${day}-${month}-${year}`;
// 	}

// 	const handleNextStep = async (event) => {
// 		event.preventDefault();

// 		let type = '';
// 		if (!rideStartDate) {
// 		notifyError('Please select Ride Start Date before proceeding.');
// 		return;
// 	}

// 		if (!choice && (tab !== 0 || action === 'allot')) {
// 			notifyError('Please select an option before proceeding.');
// 			return;
// 		}

// 		if (choice === 'driver') {
// 			type = '2';
// 		}
// 		if (choice === 'vehicle') {
// 			type = '1';
// 		} else {
// 			type = '3';
// 		}

// 		const payload = {
// 			type: type,
// 			start_date: data?.start_date,
// 			end_date: data?.end_date,
// 			vendor_id: data?.vendor_id || 1,
// 			va_vehicle_id: selectedVehicle || '',
// 			va_driver_id: selectedDriver || '',
// 			va_start_date: data?.va_start_date,
// 			va_end_date: data?.va_end_date,
// 			va_start_date_selected: formatDate(rideStartDate) || formatDate(startDate),
// 			va_end_date_selected: formatDate(endDate) || formatDate(endDate),
// 			vehicle_name_id: data?.vehicle_type_client || '',
// 			client_arrival: data?.client_arrival || '',
// 			vehicle_name: data?.vehiclename || '',
// 		};

// 		const response = await VehicleAllotServices.allotlist(payload);

// 		setAllotVehicle(response.can_allot_vehicle);
// 		setAllotDriver(response.can_allot_driver);
// 		setAlreadyAssignedVehicle(response.already_assigned_vehicle);
// 		setAlreadyAssignedDriver(response.already_assigned_driver);
// 		if (Object.keys(errors).length === 0) {
// 			setStep(step + 1);
// 		} else {
// 			notifyError('Please fill required fields');
// 		}
// 	};

// 	const handleSubmitStep = async () => {
// 		await Promise.all([validateForm()]);
// 		if (Object.keys(errors).length === 0) {
// 			if (step !== 2) {
// 				setStep(step + 1);
// 			}
// 		} else {
// 			return notifyError('Please fill required fields');
// 		}
// 	};

// 	const validateForm = async () => {
// 		await trigger();
// 		return Object.keys(errors).length;
// 	};

// 	const goToStep = async (stepNumber) => {
// 		if (Object.keys(errors).length === 0) {
// 			setStep(stepNumber);
// 		} else {
// 			return notifyError('Please fill required fields');
// 		}
// 	};

// 	const handlePreviousStep = async () => {
// 		setStep(step - 1);
// 	};

// 	useEffect(() => {
// 		if (data?.va_vehicle_id) {
// 			setSelectedVehicle(data.va_vehicle_id.toString());
// 			setvehicleName(data.vehiclename.toString());
// 		}
// 		if (data?.va_driver_id) {
// 			setSelectedDriver(data.va_driver_id.toString());
// 			setdriverName(data.driver_name.toString());
// 		}
// 		if (data?.start_date) {
// 			setStartDate(parseDate(data.start_date));
// 		}
// 		if (data?.end_date) {
// 			setEndDate(parseDate(data.end_date));
// 		}
// 	}, [data]);

// 	const {
// 		register,
// 		handleSubmit,
// 		setValue,
// 		trigger,
// 		clearErrors,
// 		reset,
// 		formState: { errors },
// 	} = useForm();

// 	// const isDateChanged = (originalStartDate, originalEndDate, newStartDate, newEndDate) => {
// 	//   const originalStart = formatDate(parseDate(originalStartDate));
// 	//   const originalEnd = formatDate(parseDate(originalEndDate));

// 	//   const newStart = formatDate(newStartDate);
// 	//   const newEnd = formatDate(newEndDate);

// 	//   return originalStart !== newStart || originalEnd !== newEnd;
// 	// };
// 	let update = '';

// 	if (tab === 0) {
// 		update = 0;
// 	}
// 	if (tab === 1) {
// 		update = 1;
// 	}
// 	if (tab === 2 && action === 'allot') {
// 		update = 0;
// 	}
// 	if (tab === 2 && action === 'modify') {
// 		update = 1;
// 	}

// 	const onSubmit = async () => {
// 		setLoading(true);
// 		const finalStep = 2;

// 		if (step !== finalStep && tab === 1) {
// 			return;
// 		}

// 		try {
// 			setIsSubmitting(true);
// 			// const dateChanged = isDateChanged(
// 			//   data.start_date,
// 			//   data.end_date,
// 			//   startDate,
// 			//   endDate
// 			// );
// 			//console.log(selectedDriver,selectedVehicle)
// 			const categoryData = {
// 				is_vendor: false,
// 				client_id: Number(data.client_id),
// 				start_date: formatDate(rideStartDate),
// 				end_date: formatDate(endDate),
// 				vendor_id: data.vendor_id,
// 				driver_id: Number(selectedDriver),
// 				vehicle_id: Number(selectedVehicle),
// 				update: update,
// 				driverName: driverName,
// 				vehicleName: vehicleName,
// 				is_date_changed: data.is_date_changed,
// 				va_id: Number(data.va_id),
// 				id_employee: adminInfo.id,
// 				vehicle_driver_change_remark: changeReason,
// 			};

// 			const res = await VehicleAllotServices.allotVehicleDriver(categoryData);
// 			setIsUpdate(true);
// 			setIsSubmitting(false);
// 			notifySuccess(res.message);
// 			closeDrawer();
// 			reset();
// 		} catch (err) {
// 			setIsSubmitting(false);
// 			notifyError(err ? err?.response?.data?.message : err?.message);
// 			//  closeDrawer();
// 		} finally {
// 			setLoading(false);
// 		}
// 	};

// 	useEffect(() => {
// 		if (!isDrawerOpen) {
// 			setStep(1);

// 			clearErrors();

// 			return;
// 		}
// 	}, [setValue, isDrawerOpen, clearErrors, data]);

// 	return {
// 		register,
// 		setStep,
// 		handleSubmit,
// 		onSubmit,
// 		trigger,
// 		errors,
// 		isSubmitting,
// 		selectedVehicle,
// 		setSelectedVehicle,
// 		selectedDriver,
// 		setSelectedDriver,
// 		setStartDate,
// 		alreadyAssignedVehicle,
// 		startDate,
// 		alreadyAssignedDriver,
// 		setEndDate,
// 		endDate,
// 		changeReason,
// 		setChangeReason,
// 		handleNextStep,
// 		handleSubmitStep,
// 		step,
// 		loading,
// 		setLoading,
// 		handlePreviousStep,
// 		goToStep,
// 		allotvehicle,
// 		allotdriver,
// 		setdriverName,
// 		setvehicleName,
// 		driverName,
// 		vehicleName,
// 		setRideStartDate,
// 		setRideEndDate,
// 		rideStartDate,
// 		rideEndDate
// 	};
// };

// export default useVehicleAllotSubmit;

import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import VehicleAllotServices from "services/VehicleAllotServices";
import { AdminContext } from "context/AdminContext";
import { notifyError, notifySuccess } from "utils/toast";

const useVehicleAllotSubmit = (data, tab, choice, action) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const { state } = useContext(AdminContext);
  const { adminInfo } = state;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(
    data?.va_vehicle_id?.toString(),
  );
  const [selectedDriver, setSelectedDriver] = useState(
    data?.va_driver_id?.toString(),
  );
  const [driverName, setdriverName] = useState(data?.driverName?.toString());
  const [vehicleName, setvehicleName] = useState(data?.vehicleName?.toString());
  const [startDate, setStartDate] = useState(null);
  const [allotvehicle, setAllotVehicle] = useState(null);
  const [alreadyAssignedVehicle, setAlreadyAssignedVehicle] = useState([]);
  const [alreadyAssignedDriver, setAlreadyAssignedDriver] = useState([]);
  const [allotdriver, setAllotDriver] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [changeReason, setChangeReason] = useState("");
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [tripwent, setTrip] = useState(false);
  const [tripStartDate, setTripStartDate] = useState(null);
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`);
  };

  //   function formatDate(dateString) {
  //     const date = new Date(dateString);
  //     const day = String(date.getDate()).padStart(2, "0");
  //     const month = String(date.getMonth() + 1).padStart(2, "0");
  //     const year = date.getFullYear();
  //     return `${day}-${month}-${year}`;
  //   }

  function formatDate(dateString) {
    // Check for empty value
    if (!dateString) return "";

    const date = new Date(dateString);

    // Check for invalid date
    if (isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
  useEffect(() => {
    if (isDrawerOpen && tab === 1 && startDate && endDate) {
      getAllotmentList();
    }
  }, [isDrawerOpen, startDate, endDate]);

  const getAllotmentList = async () => {
    if (!startDate) {
      notifyError("Please select Ride Start Date.");
      return;
    }
    const payload = {
      type: "3",
      vendor_id: data?.vendor_id || 1,
      va_start_date: formatDate(startDate),
      va_end_date: formatDate(endDate),
      vehicle_name_id: data?.vehicle_type_client || "",
    };

    const response = await VehicleAllotServices.allotlist(payload);

    setAllotVehicle(response.can_allot_vehicle);
    setAllotDriver(response.can_allot_driver);
    setAlreadyAssignedVehicle(response.already_assigned_vehicle);
    setAlreadyAssignedDriver(response.already_assigned_driver);
  };

  // const handleNextStep = async (event) => {
  //   event.preventDefault();

  //   if (!startDate) {
  //     notifyError("Please select Ride Start Date before proceeding.");
  //     return;
  //   }

  //   if (!choice && (tab !== 0 || action === "allot")) {
  //     notifyError("Please select an option before proceeding.");
  //     return;
  //   }

  //   // if (choice === "driver") {
  //   //   type = "2";
  //   // } else if (choice === "vehicle") {
  //   //   type = "1";
  //   // } else {
  //   //   type = "3";
  //   // }
  //   const type = "3";

  //   // const payload = {
  //   //   type: type,
  //   //   start_date: data?.start_date,
  //   //   end_date: data?.end_date,
  //   //   vendor_id: data?.vendor_id || 1,
  //   //   va_vehicle_id: selectedVehicle || "",
  //   //   va_driver_id: selectedDriver || "",
  //   //   va_start_date: data?.va_start_date,
  //   //   va_end_date: data?.va_end_date,
  //   //   va_start_date_selected: formatDate(startDate),
  //   //   va_end_date_selected: formatDate(endDate) || formatDate(endDate),
  //   //   vehicle_name_id: data?.vehicle_type_client || "",
  //   //   client_arrival: data?.client_arrival || "",
  //   //   vehicle_name: data?.vehiclename || "",
  //   // };

  //   const payload = {
  //     type: type,
  //     vendor_id: data?.vendor_id || 1,
  //     va_start_date:  formatDate(startDate),
  //     va_end_date:  formatDate(endDate),
  //     vehicle_name_id: data?.vehicle_type_client || "",
  //   };
  //   const response = await VehicleAllotServices.allotlist(payload);

  //   setAllotVehicle(response.can_allot_vehicle);
  //   setAllotDriver(response.can_allot_driver);
  //   setAlreadyAssignedVehicle(response.already_assigned_vehicle);
  //   setAlreadyAssignedDriver(response.already_assigned_driver);
  //   if (Object.keys(errors).length === 0) {
  //     setStep(step + 1);
  //   } else {
  //     notifyError("Please fill required fields");
  //   }
  // };

  const handleNextStep = async (event) => {
    event.preventDefault();

    await trigger();
    // if (!startDate) {
    //   notifyError("Please select Start Date.");
    //   return;
    // }
    // if (tripwent && !tripStartDate) {
    //   notifyError("Please select Start Date.");
    //   return;
    // }

    if (tripwent) {
      if (!tripStartDate) {
        notifyError("Please select Start Date.");
        return;
      }
    } else {
      if (!startDate) {
        notifyError("Please select Start Date.");
        return;
      }
    }

    if (!endDate) {
      notifyError("Please select End Date.");
      return;
    }

    if (!choice) {
      notifyError("Please select Driver, Vehicle or Both.");
      return;
    }

    if (Object.keys(errors).length > 0) {
      notifyError("Please fill all required fields.");
      return;
    }

    setStep((prev) => prev + 1);
  };

  const handleSubmitStep = async () => {
    await Promise.all([validateForm()]);
    if (Object.keys(errors).length === 0) {
      if (step !== 2) {
        setStep(step + 1);
      }
    } else {
      return notifyError("Please fill required fields");
    }
  };

  const validateForm = async () => {
    await trigger();
    return Object.keys(errors).length;
  };

  // const goToStep = async (stepNumber) => {
  //   if (Object.keys(errors).length === 0) {
  //     setStep(stepNumber);
  //   } else {
  //     return notifyError("Please fill required fields");
  //   }
  // };

  const goToStep = async (stepNumber) => {
    await trigger();

    if (!choice) {
      notifyError("Please select Driver, Vehicle or Both.");
      return;
    }

    // if (Object.keys(errors).length > 0) {
    //   notifyError("Please fill all required fields.");
    //   return;
    // }

    setStep(stepNumber);
  };
  const handlePreviousStep = async () => {
    setStep(step - 1);
  };

  const presentAllotment = data?.allotment_history?.find(
    (item) => item.status === "Present",
  );
  const parseDDMMYYYY = (dateString) => {
    if (!dateString) return null;

    const [day, month, year] = dateString.split("-");
    return new Date(year, month - 1, day);
  };

  useEffect(() => {
    if (data?.va_vehicle_id) {
      setSelectedVehicle(data.va_vehicle_id.toString());
      setvehicleName(data.vehiclename.toString());
    }
    if (data?.va_driver_id) {
      setSelectedDriver(data.va_driver_id.toString());
      setdriverName(data.driver_name.toString());
    }

    // setStartDate(parseDDMMYYYY(presentAllotment?.va_start_date));
    const originalStart = parseDDMMYYYY(presentAllotment?.va_start_date);

    setStartDate(originalStart);
    setTripStartDate(originalStart);
    setEndDate(parseDDMMYYYY(presentAllotment?.va_end_date));
  }, [data]);
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm();

  // const isDateChanged = (originalStartDate, originalEndDate, newStartDate, newEndDate) => {
  //   const originalStart = formatDate(parseDate(originalStartDate));
  //   const originalEnd = formatDate(parseDate(originalEndDate));

  //   const newStart = formatDate(newStartDate);
  //   const newEnd = formatDate(newEndDate);

  //   return originalStart !== newStart || originalEnd !== newEnd;
  // };
  let update = "";

  if (tab === 0) {
    update = 0;
  }
  if (tab === 1) {
    update = 1;
  }
  if (tab === 2 && action === "allot") {
    update = 0;
  }
  if (tab === 2 && action === "modify") {
    update = 1;
  }
  let trip;
  if (tripwent === true) {
    trip = 1;
  }
  if (tripwent === false) {
    trip = 2;
  }

  // const onSubmit = async () => {
  //   setLoading(true);
  //   const finalStep = 2;

  //   if (step !== finalStep && tab === 1) {
  //     return;
  //   }

  //   try {
  //     setIsSubmitting(true);
  //     // const dateChanged = isDateChanged(
  //     //   data.start_date,
  //     //   data.end_date,
  //     //   startDate,
  //     //   endDate
  //     // );
  //     //console.log(selectedDriver,selectedVehicle)
  //     const categoryData = {
  //       is_vendor: false,
  //       client_id: Number(data.client_id),
  //       // start_date: formatDate(rideStartDate)
  //       start_date: tripwent
  //         ? formatDate(tripStartDate)
  //         : formatDate(startDate),
  //       end_date: formatDate(endDate),
  //       vendor_id: data.vendor_id,
  //       driver_id: Number(selectedDriver),
  //       vehicle_id: Number(selectedVehicle),
  //       update: update,
  //       driverName: driverName,
  //       vehicleName: vehicleName,
  //       is_date_changed: data.is_date_changed,
  //       va_id: Number(data.va_id),
  //       id_employee: adminInfo.id,
  //       vehicle_driver_change_remark: changeReason,
  //       trip_went_or_not: trip,
  //       // update:1
  //     };

  //     const res = await VehicleAllotServices.allotVehicleDriver(categoryData);
  //     setIsUpdate(true);
  //     setIsSubmitting(false);
  //     notifySuccess(res.message);
  //     closeDrawer();
  //     reset();
  //   } catch (err) {
  //     setIsSubmitting(false);
  //     notifyError(err ? err?.response?.data?.message : err?.message);
  //     //  closeDrawer();
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const onSubmit = async () => {
    setLoading(true);
    const finalStep = 2;

    if (step !== finalStep && tab === 1) {
      return;
    }

    try {
      setIsSubmitting(true);

      const categoryData = {
        is_vendor: false,
        client_id: Number(data.client_id),
        start_date: tripwent
          ? formatDate(tripStartDate)
          : formatDate(startDate),
        end_date: formatDate(endDate),
        vendor_id: data.vendor_id,
        driver_id: Number(selectedDriver),
        vehicle_id: Number(selectedVehicle),
        update: update,
        driverName: driverName,
        vehicleName: vehicleName,
        is_date_changed: data.is_date_changed,
        va_id: Number(data.va_id),
        id_employee: adminInfo.id,
        vehicle_driver_change_remark: changeReason,
        trip_went_or_not: trip,
      };

      const res = await VehicleAllotServices.allotVehicleDriver(categoryData);

      if (res.status) {
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
        reset();
      } else {
        notifyError(res.message);
        setIsSubmitting(false);
        return;
      }
    } catch (err) {
      setIsSubmitting(false);
      notifyError(
        err?.response?.data?.message || err?.message || "Something went wrong.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setStep(1);

      clearErrors();

      return;
    }
  }, [setValue, isDrawerOpen, clearErrors, data]);

  return {
    register,
    setStep,
    handleSubmit,
    onSubmit,
    trigger,
    errors,
    isSubmitting,
    selectedVehicle,
    setSelectedVehicle,
    selectedDriver,
    setSelectedDriver,
    setStartDate,
    alreadyAssignedVehicle,
    startDate,
    alreadyAssignedDriver,
    setEndDate,
    endDate,
    changeReason,
    setChangeReason,
    handleNextStep,
    getAllotmentList,
    handleSubmitStep,
    step,
    loading,
    setLoading,
    handlePreviousStep,
    goToStep,
    allotvehicle,
    allotdriver,
    setdriverName,
    setvehicleName,
    driverName,
    vehicleName,
    setTrip,
    tripwent,
    tripStartDate,
    setTripStartDate,
  };
};

export default useVehicleAllotSubmit;
